export const qk = {
  facturas: (q: string) => ['facturas', { q }] as const,
  facturasAll: ['facturas'] as const,
  clients: (q: string) => ['clients', { q }] as const,
  clientsAll: ['clients'] as const,
  products: (q: string) => ['products', { q }] as const,
  productsAll: ['products'] as const,
  emisor: ['emisor'] as const,
  emisorMeta: ['emisor', 'metadata'] as const,
  usage: ['account', 'usage'] as const,
  passkeys: ['auth', 'passkeys'] as const,
  apiKeys: ['api-keys'] as const,
  apiKeyStats: (keyId: string, days: number) => ['api-keys', keyId, 'stats', { days }] as const,
  webhooks: ['webhook-endpoints'] as const,
  deliveries: (limit: number) => ['webhook-endpoints', 'deliveries', { limit }] as const,
};
